import { $elementChild } from "@grindex-common/helpers/elements";
import { Loader } from "@grindex-components/Loader/loader.class";
import ShipmentTrackingDomGenerator from "./ShipmentTrackingDomGenerator.class";

const ERROR_CLASS = "error";

function init($views) {
	const forms = {};
	const htmlParser = new ShipmentTrackingDomGenerator();

	function valid($input) {
		const value = $input && $input.value ? $input.value.trim() : "";

		if ($input.value && $input.value.length > 0 && value.length === 0) {
			$input.value = "";
		}

		return value.length > 0;
	}

	function validate($input) {
		return () => {
			if ($input) {
				if (!valid($input)) {
					$input.classList.add(ERROR_CLASS);
					return false;
				}

				$input.classList.remove(ERROR_CLASS);
			}

			return true;
		};
	}

	$views.forEach(($view) => {
		const $error = $elementChild($view, "search-error");
		const $button = $elementChild($view, "search-submit");
		const $result = $elementChild($view, "search-results");
		const $loader = $elementChild($view, "loader");
		const $form = $view.querySelector("form");
		let $input = $view.querySelector('input[name="orderNumber"]');

		forms[$form.dataset.ajaxUpdate] = {
			loader: new Loader($loader),
			validate: validate($input, $error),
			$input,
			$button,
			$result,
		};
	});

	window.shipmentTrackingSearchBegin = function () {
		const form = forms[this.dataset.ajaxUpdate];

		if (!form || !form.validate()) {
			return false;
		}

		const { loader, $button, $result, $input } = form;

		loader.show();
		if ($input) {
			$input.disabled = true;
		}

		$button.disabled = true;
		$result.style.display = "none";
		return true;
	};

	window.shipmentTrackingSearchComplete = function (data) {
		const results = JSON.parse(data.responseText);
		const resultsDiv = document.querySelector("#results");

		if (results.metaDataLinks.length > 0) {
			resultsDiv.innerHTML = "";
			const ul = document.createElement("ul");
			ul.className = "link-list";
			htmlParser.createDocumentLinks(results.metaDataLinks).forEach((li) => {
				ul.appendChild(li);
			});

			resultsDiv.appendChild(ul);
		} else {
			resultsDiv.innerHTML = "<h2>No results found for specified number</h2>";
		}

		const form = forms[this.dataset.ajaxUpdate];

		if (!form) {
			return false;
		}

		const { loader, $button, $result, $input } = form;

		loader.hide();

		if ($input) {
			$input.disabled = false;
		}

		$button.disabled = false;
		$result.style.display = "block";
		return true;
	};
}

export default {
	view: "shipmentTracking-search-block",
	init,
};
